<div class="mb-2 flex w-full justify-end font-lato">
  <div class="flex w-full md:pl-4 lg:w-1/2">
    <mat-form-field class="w-auto">
      <mat-label>Select a time range</mat-label>
      <mat-select
        [(value)]="selectedTimeRange"
        (selectionChange)="onTimeRangeChange($event)"
      >
        <mat-option [value]="''">No Time Range</mat-option>
        <mat-option value="6hours">Last 6 hours</mat-option>
        <mat-option value="1day">Last 24 hours</mat-option>
        <mat-option value="1month">Last 30 days</mat-option>
        <mat-option value="3months">Last 90 days</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="flex flex-col gap-2 md:gap-4 md:pl-4 lg:flex-row">
  <div
    class="flex w-full flex-1 flex-col rounded-xl bg-black/10 px-10 py-2 shadow-inner xl:py-5"
  >
    <div class="flex w-full items-center justify-center md:min-w-[210px]">
      <div class="text-[5rem] font-normal leading-[6rem]">
        @if (isLoading) {
          <div class="loading-spinner">
            <mat-spinner [diameter]="30"></mat-spinner>
          </div>
        } @else {
          {{ ticketTypeCount?.proactive || 0 }}
        }
      </div>
      <div class="pl-4 pt-2 text-base font-bold uppercase leading-6">
        Proactive
        <span class="flex text-[40px] font-normal normal-case leading-[48px]"
          >Ticket{{ ticketTypeCount?.proactive === 1 ? '' : 's' }}</span
        >
      </div>
    </div>
    <div class="ticket-averages text-center font-normal">
      <div>
        Average Pickup Time:
        <span>{{ proactiveAverageTimeToFirstTouch }}</span>
      </div>
      <div>
        Average Repair Time: <span>{{ proactiveAverageTimeToRepair }}</span>
      </div>
    </div>
  </div>
  <div
    class="flex w-full flex-1 flex-col rounded-xl bg-black/10 px-10 py-2 shadow-inner xl:py-5"
  >
    <div class="flex w-full items-center justify-center md:min-w-[210px]">
      <div class="text-[5rem] font-normal leading-[6rem]">
        @if (isLoading) {
          <div class="loading-spinner">
            <mat-spinner [diameter]="30"></mat-spinner>
          </div>
        } @else {
          {{ ticketTypeCount?.nonProactive || 0 }}
        }
      </div>
      <div class="pl-4 pt-2 text-base font-bold uppercase leading-6">
        Non-Proactive
        <span class="flex text-[40px] font-normal normal-case leading-[48px]">
          Ticket{{ ticketTypeCount?.nonProactive === 1 ? '' : 's' }}
        </span>
      </div>
    </div>
    <div class="ticket-averages text-center font-normal">
      <div>
        Average NOC Pickup Time:
        <span>{{ nonProactiveAverageTimeToFirstTouch }}</span>
      </div>
      <div>
        Average NOC Repair Time:
        <span>{{ nonProactiveAverageTimeToRepair }}</span>
      </div>
    </div>
  </div>
</div>
